<script setup>
import HelpHubLinkCard from './HelpHubLinkCard.vue'
import { HELP_HUB_TOPICS, useHelpTopics } from '@/hooks/useHelpTopics'

// The rows, and what makes each a control, are shared with the search results.
const { control } = useHelpTopics()
</script>

<template>
  <section class="flex flex-col gap-y-4 border-t border-gray-200 px-4 py-5">
    <h3 class="text-base font-semibold text-gray-900">Explore help topics</h3>

    <ul class="flex flex-col gap-y-4">
      <li v-for="topic in HELP_HUB_TOPICS" :key="topic.key">
        <HelpHubLinkCard
          v-bind="control(topic)"
          :title="topic.title"
          :description="topic.description"
          icon="heroicons-outline:information-circle"
        />
      </li>
    </ul>
  </section>
</template>
